export default __webpack_public_path__ + "static/Blaue_Nacht_2020-04-30_6709-cadf68452babdfaaefec2c773631d1c1.jpg";